var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wound-healing-template',{attrs:{"prolonged-healing-time":_vm.prolongedHealingTime,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }